import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * FA STARE UN FOGLIO SOPRA LA BARRA IN BASSO, anche quando nasce dentro un contenitore che lo intrappola.
 *
 * 🔴 IL DIFETTO (regressione di #598 «la barra in basso si vede SEMPRE», servita su stg-tma dalle 00:20Z del 05/10).
 * Un foglio e' `fixed … z-50`, e la barra e' un `<nav sticky z-10>` fratello di `<main>`. Ma un `z-50` vale solo dentro il
 * PROPRIO contesto di sovrapposizione: se un antenato ne crea uno (`isolate`, `transform`, `opacity`, `filter`, un `z-*` su un
 * posizionato), il foglio e' intrappolato li' dentro e l'intero contenitore si dispone a livello 0 della pagina — SOTTO la
 * barra, che sta a 10 e viene dopo nel documento. La schermata di gioco in verticale ha come radice un `<div isolate>` (per il
 * suo velo `-z-10`): ogni foglio che apre (risposta alla pausa, proposta, offerta di ritiro, la griglia delle emoji) aveva gli
 * ultimi 82 px sotto la barra, e Accetta/Rifiuta non si toccavano. [M banco a pixel, 390×844 e 360×640, `?barra=1`:
 * `tools/banco-pixel/fogli-sopra-la-barra.mjs`, 14 violazioni su 8 casi prima della cura, 0 dopo.]
 *
 * ⇒ Il portale su `document.body`: fuori da ogni contenitore, il `z-50` torna a valere contro la barra. E' la stessa soluzione
 * di `RigaGioco` (il selettore del gioco) e del modale «Impostazioni partita», e questo e' l'UNICO punto che la dice: chi ne ha
 * bisogno usa questo componente, non scrive un secondo `createPortal(…, document.body)`.
 *
 * `attivo={false}` lascia il figlio dov'e': serve all'ORIZZONTALE, dove il foglio sta DENTRO la scatola ruotata del tavolo e
 * ci deve restare — un antenato `transform` e' il blocco contenitore del suo `fixed`, quindi ruota col tabellone, e fuori dalla
 * scatola finirebbe dritto sopra un tavolo girato. Li' la scatola finisce SOPRA la barra per costruzione (`ALTEZZA_TABBAR_VAR`).
 *
 * ⛔ NON mettere un foglio in un portale a occhio: un foglio che sta in un contenitore SENZA contesto di sovrapposizione non ha
 * il difetto (e `Sheet` da solo, nelle rotte della shell, sta sopra la barra: misurato nell'inventario della PR), e spostarlo
 * cambia dove vive nel DOM (test che cercano dentro il contenitore, ordine di `z-50` fra due fogli, tasto indietro).
 */
export function SopraLaBarra({ children, attivo = true }: { children: ReactNode; attivo?: boolean }) {
  return attivo ? createPortal(children, document.body) : <>{children}</>;
}
